import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=d2e73c2e&scoped=true&"
import script from "./clientDetail.vue?vue&type=script&lang=js&"
export * from "./clientDetail.vue?vue&type=script&lang=js&"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=d2e73c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e73c2e",
  null
  
)

export default component.exports